import { render, staticRenderFns } from "./newSelect.vue?vue&type=template&id=7c893e32&scoped=true&"
import script from "./newSelect.vue?vue&type=script&lang=js&"
export * from "./newSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c893e32",
  null
  
)

export default component.exports